import utils from '../utils';

export default class UApi {
  url: string = '';

  constructor(url: string = '') {
    console.log('initial url', url);
    if (url[url.length - 1] === '/') {
      url = url.slice(0, -1);
    }
    this.url = url;
    console.log('this.url', this.url);
  }

  getFullUrl(path: string) {
    // if (!path) return this.url;
    if (path.length && path[0] !== '/') path = `/${path}`;
    return this.url + path;
  }

  post(path: string = '', payload: any = {}, method = 'post', contentType = 'application/json') {
    const isJSON = contentType.toLowerCase().search('json') !== -1;
    const body = isJSON ? JSON.stringify(payload) : payload;

    return window
      .fetch(this.getFullUrl(path), {
        headers: {
          Accept: 'application/json',
          'Content-Type': contentType,
        },
        credentials: 'include',
        method,
        body,
      })
      .then(status)
      .then(json);
  }

  upload(path: string = '', imageField) {
    const image = imageField.files[0];
    const formData = new window.FormData();
    formData.append('file', image);

    return window
      .fetch(this.getFullUrl(path), {
        headers: {
          Accept: 'application/json',
        },
        credentials: 'include',
        method: 'post',
        body: formData,
      })
      .then(status)
      .then(json);
  }

  put(path: string = '', payload: any = {}, contentType?) {
    return this.post(path, payload, 'put', contentType);
  }

  get(path: string = '', queryParams?, method = 'get', headers: { [key: string]: string } = {}) {
    const uriEncoded = utils.uriEncode(queryParams);
    return window
      .fetch(this.getFullUrl(path) + uriEncoded, {
        method,
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT',
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          ...headers,
        },
        cache: 'reload',
      })
      .then(status)
      .then(json);
  }

  delete(path: string = '', queryParams?) {
    return this.get(path, queryParams, 'delete');
  }
}

function json(response: Response) {
  if (response && typeof response === 'object' && response.json) {
    return response.json().catch(() => ({
      status: response.status,
      message: response.statusText,
      response,
    }));
  }
  return Promise.resolve(response);
}

function status(response: Response) {
  if (response.ok) {
    return Promise.resolve(response);
  }

  return json(response).then((jsonObj) => {
    // eslint-disable-next-line no-param-reassign
    jsonObj.status = response.status;
    return Promise.reject(jsonObj);
  });
}
